import '../styles/css/Background.css';
import React from 'react'

function Background() {
    return (
        <div id="full-background">
            <div id="image-bc">

            </div>
        </div>
    )
}

export default Background
